import "core-js";

import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { ConfigProvider } from "antd";
import fa_IR from "antd/lib/locale-provider/fa_IR";
import Router from "./router";
import store from "./scripts/store";

import "leaflet/dist/leaflet.css";
import "./styles/globals.less";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <ConfigProvider direction="rtl" locale={fa_IR}>
    <Provider store={store}>
      <Router />
    </Provider>
  </ConfigProvider>
);
